const YTPlayer = require('yt-player');
const axios = require('axios').default;
const { gsap } = require("gsap/gsap-core");
const { CSSPlugin } = require("gsap/CSSPlugin");
gsap.registerPlugin(CSSPlugin);

class FoodTruck {

  constructor() {
    this.data = {};
    this.player = null;
    this.id = '';
    this.videoElm = document.querySelector('.banner__video');
    this.videoTag = document.querySelector('.video-tag');
    this.videoPlay = document.querySelector('.video-play');
    this.videoPlaceholder = document.querySelector('.video-placeholder');
    this.hamburger = document.querySelector('.header__hamburger');
    this.navigation = document.querySelector('.header__nav');
    this.header = document.querySelector('.header');
    this.banner = document.querySelector('.banner');
    this.form = document.querySelector('#form');
    this.thankYou = document.querySelector('.thank-you');
    this.nominate = document.querySelector('.js-form');
    this.accordion = document.querySelectorAll('.accordion__item');
    this.timer;
  }

  init() {
    if (document.querySelector('.truck')) this.animateTruck();
    fetch("config/settings.json")
      .then(response => response.json())
      .then(json => {
        this.data = json;
        console.log(json);
        this.setUpVideo();
      });
    // .catch(err => { console.log(err) });

    this.hamburger.addEventListener('click', this.mobileMenu.bind(this));
    this.navigation.addEventListener('click', this.closeNav.bind(this));
    this.nominate.addEventListener('click', this.openForm.bind(this));
    setTimeout(() => { this.makeAccordion() }, 100);
    window.addEventListener('resize', this.debounce(() => this.makeAccordion()));
    window.addEventListener('scroll', this.debounce(() => this.setHeader(), 20));
  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  setHeader() {
    if (window.pageYOffset > 2) {
      this.header.classList.add('scroll');
    } else {
      this.header.classList.remove('scroll');
    }
  }

  animateTruck() {
    const city = gsap.timeline({ repeat: -1 });
    city
      .to(".city", { x: '-100%', duration: 20, ease: "none" });
    const wheels = gsap.timeline({ repeat: -1 });
    wheels
      .to("#front", { transformOrigin: "50% 50%", rotation: 360, duration: 3, ease: "none" }, 0)
      .to("#back", { transformOrigin: "50% 50%", rotation: 360, duration: 3, ease: "none" }, 0);
    const tl = gsap.timeline({ repeat: -1 });
    tl
      .to(".truck svg", { transformOrigin: "100% 100%", y: -2, rotation: 0, duration: 0.5 })
      .to(".truck svg", { transformOrigin: "100% 100%", y: 0, rotation: 0.3, duration: 0.5 })
      .to(".truck svg", { transformOrigin: "100% 100%", y: -2, rotation: -0.2, duration: 0.5 })
      .to(".truck svg", { transformOrigin: "100% 100%", y: 0, rotation: 0.2, duration: 0.5 })
      .to(".truck svg", { transformOrigin: "100% 100%", y: -2, rotation: 0, duration: 0.5 })
      .to(".truck svg", { transformOrigin: "100% 100%", y: 0, rotation: 0, duration: 0.5 });

    const MMMM = gsap.timeline({ repeat: -1, repeatDelay: 0 });
    MMMM
      .to(".M", { delay: 5, stagger: 0.1, transformOrigin: "50% 50%", y: "-=100px", scale: 1.5, rotation: 3, z: 10, duration: 0.6, ease: "power1.inOut" })
      .to(".M", { stagger: 0.1, transformOrigin: "50% 50%", y: "+=100px", scale: 1, rotation: 0, z: 0, duration: 0.6, ease: "power1.inOut" }, '-=0.4')
      .to(".T", { transformOrigin: "50% 50%", scale: 1.1, rotation: 2, duration: 0.3, ease: "power1.inOut" }, '-=0.4')
      .to(".T", { transformOrigin: "50% 50%", scale: 1, rotation: 0, duration: 0.3, ease: "power1.inOut" });
    // setTimeout(() => {
    //   this.banner.classList.remove('fade');
    // }, 100);
  }

  makeAccordion() {
    this.accordion.forEach((item) => {
      item.classList.remove('open');
      const toggle = item.querySelector('.accordion__toggle');
      const minHeight = toggle.getBoundingClientRect().height;
      item.style.maxHeight = `${minHeight}px`;
      // console.log(minHeight);

      toggle.addEventListener('click', (e) => {
        item.classList.toggle('open');
        let maxHeight = item.querySelector('.accordion__content').getBoundingClientRect().height;
        maxHeight = maxHeight + minHeight;
        item.style.maxHeight = item.classList.contains('open') ? `${maxHeight}px` : `${minHeight}px`;
        console.log(maxHeight);
      });
    });
  }

  setUpVideo() {
    if (this.data["video-url"] && this.data["video-url"].includes('youtube')) {
      this.id = this.data["video-url"].split('?v=')[1].substring(0, 11);

      this.player = new YTPlayer(this.videoTag, {
        modestBranding: true,
        related: false
      });
      this.player.load(this.id);

      document.body.classList.add('video');

      this.player.on('ended', () => {
        this.videoPlaceholder.classList.remove('hide');
      })

      this.videoPlay.addEventListener('click', () => {
        this.player.play();
        this.videoPlaceholder.classList.add('hide');
      });
    } else {
      console.log('Not Youtube, do we need MP4 support?');
    }
  }

  mobileMenu() {
    this.hamburger.classList.toggle('open');
    this.navigation.classList.toggle('open');
  }

  closeNav() {
    this.hamburger.classList.remove('open');
    this.navigation.classList.remove('open');
  }

  openForm(e) {
    console.log(!this.form.classList.contains('js-open'));
    if (!this.form.classList.contains('js-open')) {
      console.log('Opening');
      e.preventDefault();
      this.form.classList.add('js-open');
      this.nominate.classList.remove('js-nominate');
      this.nominate.innerHTML = "<span>Submit</span>";
      scroll({
        top: this.form.offsetTop - 100,
        behavior: "smooth"
      });
    } else {
      console.log('Sending');
      this.sendForm();
    }
  }

  sendForm() {
    console.log('sendForm');
    const data = {
      "name": this.form.querySelector('#name').value,
      "email": this.form.querySelector('#email').value,
      "phone": this.form.querySelector('#phone').value,
      "cause": this.form.querySelector('#cause').value,
    }
    axios({
      url: 'https://primo.com.au/foodtruck/email.php',
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      data: encodeURI(`name=${data.name}&email=${data.email}&phone=${data.phone}&cause=${data.cause}`)
    })
      .then((response) => {
        console.log(response);
        this.thankYou.classList.add('success');
        this.thankYou.innerHTML = '<h3>Thank you for your submission.</h3>';
      })
      .catch((error) => {
        console.log(error);
        this.thankYou.classList.add('error');
        this.thankYou.innerHTML = '<h3>There has been an error please check your details.</h3>'
      });
  }

}

const LOAD = new FoodTruck();
LOAD.init(); 